import script from "./tenant-switching-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenant-switching-modal.vue?vue&type=script&setup=true&lang=ts"

import "./tenant-switching-modal.vue?vue&type=style&index=0&id=c08e8b44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c08e8b44"]])

export default __exports__